import {Breadcrumb} from "antd";
import React, {useMemo} from "react";
import {useLocation} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {BreadcrumbItemType} from "antd/es/breadcrumb/Breadcrumb";

type BreadcrumbProps = {
  t?: (text: string) => string;
  paths?: string[];
  shape?: "round" | "default";
  className?: string;
};

export const CustomBreadcrumb = ({
                                   paths: pathsProp, shape = "default",
                                 }: BreadcrumbProps) => {
  const location = useLocation();
  const {t} = useTranslation('common');
  
  const paths: BreadcrumbItemType[] = useMemo(() => {
    let breadPaths: BreadcrumbItemType[] = [];
    if (!!pathsProp) {
      breadPaths = pathsProp.map(path => ({title: t(path)}))
    }
    else {
      let paths = location.pathname.split("/")
                          .filter((p) => p.length > 0);
      for (let i = 0; i < paths.length; i++) {
        let path = paths[i];
        for (let j = 0; j < i; j++) {
          path = paths[j] + "." + path;
        }
        breadPaths.push({title: t(path)});
      }
    }
    return breadPaths;
  }, [location.pathname, pathsProp, t]);
  
  return (<Breadcrumb separator=">" className={"breadcrumb " + shape} items={paths} />)
};
